import { render, staticRenderFns } from "./bulk-messages-history.vue?vue&type=template&id=6436f56c&scoped=true"
import script from "./bulk-messages-history.vue?vue&type=script&lang=js"
export * from "./bulk-messages-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436f56c",
  null
  
)

export default component.exports